module.exports = __webpack_public_path__ + "img/pinggu_bg2.f705bfb0.png";